define(function(require) {
	//views
	const MapView = require('civicsViews/agencymap_view/v_agencymap');
	const mapToggleView = require('./v_lov_map_toggle');

	//templates
	const tpl = require('./t_lov_location_selection.hbs');

	//models
	const IPSModel = require('civicsBase/ipsModel');

	//collections
	const autocompleteCollection = require('civicsCollections/location/location_autocomplete_collection');
	const locationDataCollection = require('civicsCollections/location/location_data_autocomplete_collection');

	//Utilities
	const view_manager = require('civicsUtils/view_manager');
	//This needs to be moved into the common utilities.
	const loading_manager = require('civicsUtils/loading_manager');
	const AvailableFeatures = require('civicsUtils/available_features');

	//extensions - (See bottom of file)
	const location_selection_logic = require('./location_selection_logic');




	/********************************************************************* */
	/* 	IMPORTANT: This object is extended in location_selection_logic.	   */
	/*	If you can't find this.whatever in this file, look there.		   */
	/********************************************************************* */
	return Marionette.LayoutView.extend({
		className: "location-selection",
		extent: '',
		template: tpl,
		regions: {
			mapRegion: '@ui.mapRegionDiv',
			mapToggleRegion: '@ui.mapToggle'
		},
		ui: {
			autocompleteInput: '.autocomplete-address input',
			messagesDiv: '.address-field-wrapper .messages',
			mapRegionDiv: '.myProjectMap',
			mapToggle: '.map-toggle-region',
			locateMeButton: '.locate-me',
			locationDetailsTextArea: 'textarea.site-location-details',
			mapWrapper: '.map-wrapper',
			leftSide: '.left-side'
		},
		events: {
			'click @ui.locateMeButton': 'locateMeClicked',
			'keyup @ui.autocompleteInput': 'addressFieldTyping',
			'focus @ui.locationDetailsTextArea': 'onFocus'
		},
		initialize: function (options) {
			this.config = _.isEmpty(options.config) ? {} : options.config;
			if (_.isEmpty(this.config.globalConfig)) {
				this.config.globalConfig = view_manager.globalConfig().toJSON();
			}
			this.countryCode = this.getCountryCode(this.config.globalConfig.cultureInfo);
			this.locateMeTimeOut = AvailableFeatures.locateMeTimeout() ? this.config.globalConfig.gis.locateMeTimeout : 7500;

			//providedSite can be from clone, or saved instrument kinda thing. Basically, when the map loads up, show this site on it, as if it was just selected.
			this.providedSite = options.providedSite;
			this.providedLocationDetails = options.providedLocationDetails;

			//used to ensure we don't try to alter the UI before render finishes.
			//The location services will clear/fill the autocomplete field, and can finish before the render.
			this.isRenderedPromise = $.Deferred();
			this.mapReadyPromise = $.Deferred();
			this.mapExtentPromise = $.Deferred();

			this.setupMapAndExtent(options);

			this.setupLocationServices();

		},
		onFocus: function() {
			if ($(".additional-information-wrapper").find('.helper-msg').length == 0) {
				this.ui.locationDetailsTextArea.maxlength();
			}//return character counter
		},
		onRender: function () {
			//if the geo Location service status & coordinates have not been determined yet, we'll listen to the render promise to 
			//make sure we update the button when we get it. Other wise the locate me button may or may not show properly.
			//if it's already been resolved, then this code will never fire and that's fine - the proper data will have been set.
			if (this.showLocateMeButtonPromise.state() == 'pending') {
				this.showLocateMeButtonPromise.done(() => {
					if (this.locationServicesAvailable) {
						//not ideal to reach out and touch the dom like this.
						//but because of the map, we can't call this.render willy nilly.
						//also throws a series of confusing errors if we render too soon while the map is still setting up
						this.ui.locateMeButton.removeClass('hide');
					}
				});
			}
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();

			this.isRenderedPromise.resolve();
		},
		onShow: function () {
			this.handleOverlay();
			$.when(this.mapExtentPromise).always(() => {
				this.setupAutocomplete(this.config.newLocation.addressMoniker, {
					countryCode: this.countryCode,
					extent: this.extent,
					maxSuggestions: this.config.newLocation.maxSuggestions,
					location: '',
					f: 'json'
				}, this.config.newLocation.searchExtentSize);
			})

			this.displayMap();
			this.on('civics:map-click-results', (res) => {
				this.mapClicked(res, this.config.newLocation.searchExtentSize);
			});

			//this sets up the event handling for no results from autocomplete
			this.ui.autocompleteInput.on('requestend', this.autocompleteRequestCompleted.bind(this));
			
			this.ui.locationDetailsTextArea.val(this.providedLocationDetails);
			this.ui.locationDetailsTextArea.maxlength();
		},
		addressFieldTyping: function () {
			var oldVal = this.ui.autocompleteInput.data('oldValue');
			var val = this.ui.autocompleteInput.val();
			//check that the oldvalue and the current value don't match. this means they typed something, as opposed to just navigating the text string with arrow keys
			//also check to see if val is short/less than the number of characters to trigger autocomplete. We still want to clear messages and reset the object in that case.
			if ((oldVal != undefined && oldVal != val) || (val != undefined && val.length <= 3)) {
				//first argument is the method being used currently, second is whether to keep the autocomplete field populated
				this.resetLocation({
					autocomplete: true
				}, true);
			}

		},
		//fires whenever the AC service fetch finishes. we only want to do anything if it's empty.
		autocompleteRequestCompleted: function (args, typedText, response) {
			if (response && response.length == 0) {
				this.showError(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.NO_RESULTS_RETURNED_ERROR'))
			}
		},
		clearAutocomplete: function () {
			//if the view hasn't been rendered, there isn't anything to clear anyways. no need to set up a .done
			if (this.isRenderedPromise.state() == 'resolved') {
				this.ui.autocompleteInput.val('');
				this.ui.autocompleteInput.removeData('oldValue');
			}
		},
		displayMap: function () {
			if (this.mapEnabled) {
				this.mapRegion.show(new MapView({
					config: {
						mapConfig: this.mapConfigName,
						channel: this,
						regionId: this.mapRegionId
					}
				}));

				this.mapToggleModel = new IPSModel({
					mapToggle: true
				});
				this.mapToggleModel.on('change', () => {
					if (this.mapToggleModel.get('mapToggle')) {
						this.ui.mapWrapper.show(250);
					} else {
						this.ui.mapWrapper.hide(250);
					}
				});
				this.mapToggleRegion.show(new mapToggleView({
					mapStateName: this.mapStateName,
					model: this.mapToggleModel
				}));
			} else {
				this.ui.mapWrapper.hide();
				this.ui.leftSide.hide();
			}
		},
		displayMessage: function (text) {
			if (this.isRenderedPromise.state() == 'resolved') {
				this.ui.messagesDiv.text(text);
			} else {
				this.isRenderedPromise.done(() => {
					this.displayMessage(text);
				})
			}
		},
		handleOverlay: function () {
			loading_manager.loading(true, this);
			//place an overlay while the map is loading. Then continue to show it until all the init calls are finished.
			$.when(this.mapReadyPromise, this.mapExtentPromise, this.locationServicesAvailablePromise, this.showLocateMeButtonPromise).always(() => {
				loading_manager.loading(false, this);
			})
		},
		setupLocationServices: function () {
			this.useLocationServices = this.config.newLocation.useLocationServices === true;
			this.locationServicesAvailable = false;
			this.showLocateMeButtonPromise = $.Deferred();

			if (this.useLocationServices) {
				this.mapExtentPromise.done(() => {
					this.locationServicesAvailablePromise = this.getUsersLocation(this.extent, this.locateMeTimeOut);
				});
			} else {
				this.locationServicesAvailablePromise = $.Deferred();
				this.locationServicesAvailablePromise.resolve(false);
				this.showLocateMeButtonPromise.resolve();
			}

			$.when(this.locationServicesAvailablePromise, this.mapExtentPromise, this.mapReadyPromise).done(() => {
				//for whatever reason we cant get teh parameters from the promise in a when. Even though we should be able to.
				this.locationServicesAvailablePromise.done((coords) => {
					if (coords !== false) {
						this.showLocateMeButton(true);
						if (this.providedSite == null) {//don't show users location if we have a site to show already, either from clone or saved instrument
							this.getIPSAddressForCoordinates(coords, this.config.newLocation.searchExtentSize);
						}
					} else {
						this.showLocateMeButton(false);
					}
				});
				this.processProvidedSite(this.providedSite, this.config.newLocation.searchExtentSize);
			});
		},
		showLocateMeButton: function (show) {
			this.locationServicesAvailable = show;
			this.showLocateMeButtonPromise.resolve();
		},
		locateMeClicked: function (e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}

			var locateMePromise = this.getUsersLocation(this.extent, this.locateMeTimeout);
			locateMePromise.done((coords) => {
				if (coords !== false) {
					this.getIPSAddressForCoordinates(coords, this.config.newLocation.searchExtentSize);
				} else { //this code should never really fire. If the location is outside of the extent, the locate me button should be hidden. 
					this.showError(i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.OUT_OF_EXTENT_ERROR_LOCATE_ME'));
				}
			})
		},
		resetErrorMessages: function () {
			view_manager.resetErrorMessages(this);
		},
		setAddressFieldToAddress(addressDisplayText) {
			if (this.isRenderedPromise.state() == 'resolved') {
				this.ui.autocompleteInput.val(addressDisplayText);
				//set the address display text to "oldValue" so we can compare it on keyup events. 
				//if it hasn't changed, don't clear the location object.
				this.ui.autocompleteInput.data('oldValue', addressDisplayText);
			} else {
				this.isRenderedPromise.done(() => {
					this.setAddressFieldToAddress(addressDisplayText);
				})
			}
		},
		setupMapAndExtent: function (options) {
			this.mapStateName = options.mapStateName;
			this.mapConfigName = options.mapConfigName;
			this.mapRegionId = options.mapRegionId;
			this.showAdditionalLocationInformation = this.config.showAdditionalLocationInformation;
			this.mapEnabled = (!_.isEmpty(this.config.globalConfig.gis) ? this.config.globalConfig.gis.enabled : false) && !_.isEmpty(this.mapConfigName);

			if (this.mapEnabled) {
				this.fetchMapExtent(this.mapConfigName)
					.done((response) => {
						if (response.extent) {
							this.extent = response.extent;
							this.mapExtentPromise.resolve();
						} else {
							//our backup option is to use the extent from the portlet config
							this.extent = this.getExtentFromConfig(this.config);
							this.mapExtentPromise.resolve();
						}
					})
					.fail(() => {
						this.extent = this.getExtentFromConfig(this.config);
						this.mapExtentPromise.resolve();
					});
				this.mapState = view_manager.getMapState('CIVICS', this.mapStateName);


				this.on("map:ready", function () {
					setTimeout(() => {
						this.mapReadyPromise.resolve();
					}, 500);

				}.bind(this));

				this.on("map:adminfailure", function () {
					setTimeout(() => {
						this.mapReadyPromise.resolve();
					}, 500);

				}.bind(this));

			} else {
				//if the map is disabled, we still need an extent for the autocomplete. we can get that from the config.
				this.extent = this.getExtentFromConfig(this.config);
				this.mapExtentPromise.resolve();
				this.mapReadyPromise.resolve();
			}
		},
		showError: function (errorText) {
			view_manager.errorToWindow({
				validationError: {
					text: errorText
				}
			}, this);
		},
		submitData() {
			var data = {};
			data.location = this.ui.locationDetailsTextArea.val();
			return this.processLocationData(data);
		},
		templateHelpers: function () {
			return {
				mapEnabled: true,
				showAdditionalLocationInformation: this.showAdditionalLocationInformation,
				locationServicesAvailable: this.locationServicesAvailable,
				hideOrShowLocateMeButton: this.locationServicesAvailable ? "" : " hide",
				locationRequired: this.config.isAddressRequired === true
			}
		}
	}).extend(location_selection_logic);
});